/*
 * BestyBuys - keeps the "You save ..." line of the Product Offers box correct when a customer picks
 * another variant. Only loaded when that line is switched on in the Theme Editor.
 * The wording, the minimum discount and the money format come from data attributes written by
 * snippets/bb-product-offers-saving.liquid, so nothing is fixed here.
 */
(function () {
  'use strict';
  if (window.bbOffersSave) return;

  function group(n, sep) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  /* Money in the store's own format (same rules as Shopify's money filters), without a trailing ".00" */
  function money(cents, format) {
    var match = /\{\{\s*(\w+)\s*\}\}/.exec(format || '');
    var type = match ? match[1] : 'amount';
    var decimals = type.indexOf('no_decimals') > -1 ? 0 : 2;
    var thousands = ',';
    var point = '.';
    if (type.indexOf('comma_separator') > -1) {
      thousands = '.';
      point = ',';
    } else if (type.indexOf('apostrophe_separator') > -1) {
      thousands = "'";
    } else if (type.indexOf('space_separator') > -1) {
      thousands = ' ';
    }
    var value = (Math.round(cents) / 100).toFixed(decimals).split('.');
    var text = group(value[0], thousands) + (value[1] && value[1] !== '00' ? point + value[1] : '');
    return (format || '{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, text);
  }

  function apply(line, variant) {
    var target = line.querySelector('.bb-po__save-text');
    if (!target) return;
    var compare = variant && variant.compare_at_price ? Number(variant.compare_at_price) : 0;
    var price = variant && variant.price ? Number(variant.price) : 0;
    var saved = compare - price;
    var percent = compare > 0 ? Math.round((saved * 100) / compare) : 0;
    var min = parseFloat(line.getAttribute('data-min'));
    if (isNaN(min)) min = 0;
    if (!variant || saved <= 0 || percent <= 0 || percent < min) {
      line.hidden = true;
      return;
    }
    var template = line.getAttribute('data-tpl') || 'You save {amount} ({percent}% off)';
    target.textContent = template
      .replace('{amount}', money(saved, line.getAttribute('data-money-format')))
      .replace('{percent}', String(percent));
    line.hidden = false;
  }

  window.bbOffersSave = { money: money, apply: apply };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.variant) return;
      document.querySelectorAll('[data-bb-save]').forEach(function (line) {
        var section = line.getAttribute('data-section-id');
        if (section && data.sectionId && section !== data.sectionId) return;
        apply(line, data.variant);
      });
    });
  }
})();
